'use client';

import React from 'react';
import { type LayoutProps } from './layout.type';
import { Header, LoadImgWithFallback } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { COMMON } from '$locale/constants';
import styles from './layout.module.scss';
import { START_SCREEN_IMAGE_URL } from '$modules/onboarding/constants/layout';
const LayoutWeb: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    t
  } = useLocale(COMMON);
  const image = `${START_SCREEN_IMAGE_URL}/Internal_new.png`;
  return <>
      <div style={{
      display: 'flex',
      height: '100%'
    }}>
        <div style={{
        width: '50%',
        position: 'relative'
      }}>
          <Header type="ops" data-sentry-element="Header" data-sentry-source-file="layout.web.tsx" />
          <div className={styles.container} data-testid="carouselItemStartScreen">
            <LoadImgWithFallback imageUrl={image} alt="Image not found" className={styles.screenImg} testId="image" data-sentry-element="LoadImgWithFallback" data-sentry-source-file="layout.web.tsx" />
            <div className={styles.headingContainer}>
              {t('startScreen.heading')}
            </div>
          </div>
        </div>
        <div style={{
        width: '50%',
        margin: 'auto'
      }}>{children}</div>
      </div>
    </>;
};
export default LayoutWeb;